<template>
  <section class="cmp cmp-page-title">
    <slot>
      <h2>{{ name }}</h2>
    </slot>
  </section>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '无',
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-page-title {
  text-align: center;
  h3 {
    margin: 0;
    font-size: 24px;
  }
  h2 {
    margin: 0;
    display: inline-block;
    position: relative;
    line-height: 80px;
    font-size: 28px;
    letter-spacing: 1px;
    background: url('~@/assets/images/public/page-icon-1.png') center no-repeat;
  }
  h2:before {
    position: absolute;
    left: -80px;
    top: 50%;
    transform: translateY(-50%);
    width: 43px;
    height: 24px;
    content: '';
    background: url('~@/assets/images/public/page-icon-2.png') center no-repeat;
  }
  h2:after {
    position: absolute;
    right: -80px;
    top: 50%;
    transform: translateY(-50%);
    width: 43px;
    height: 24px;
    content: '';
    background: url('~@/assets/images/public/page-icon-3.png') center no-repeat;
  }
}
</style>
